// extracted by mini-css-extract-plugin
export default {"card":"MGCard_card__mR7aF"};